"use client";
import { useGlobalContext } from "@/app/context/store";

export default function DisplayErrorJobLimit({ translations }: { translations: any }) {
  const { user } = useGlobalContext();
  return (
    <>
      {/* Wait for Current Generation to Complete State*/}
      <div
        className={`px-auto flex h-[calc(100vw-32px)] w-full items-center justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] text-center sm:h-[60vh] sm:rounded-b-xl`}
      >
        <div className="mx-5 font-medium text-white sm:mx-20">
          {translations.imageLoadingState3}
          <div
            className={`${
              user?.membership?.level === 0 ||
              user?.membership?.level === -1 ||
              user?.membership === undefined
                ? "block"
                : "hidden"
            }`}
          >
            <br />
            <br />
            <a href={translations.path + "upgrade"} className="underline">
              {translations.imageLoadingState4pt2}
            </a>
            {translations.imageLoadingState4pt3}
          </div>
        </div>
      </div>
    </>
  );
}
